<template>
  <div>
    <!-- ---头部--- -->
    <content-title title="机组信息" />
    <!-- ---说明--- -->
    <write-instruction>
      <p>1、 发电燃料类型按照燃煤、燃油或者燃气划分，可采用机组运行规程或铭牌信息等进行填报，仅可选其中一种，使用燃煤的应选择“燃煤”。</p>
      <p>2、
        对于CCPP，视为一台机组进行填报。同一法人边界内有两台或两台机上机组的，在产出相同（如都为纯发电或者都为热电联产）、机组压力参数相同、装机容量等级相同、锅炉类型相同（如都是煤粉炉或者都是流化床锅炉）的情况下：</p>
      <p class="indentation-2">a）如果为母管制或其他情形，燃料消耗量、供电量或者供热量中有任意一项无法分机组计量的，可合并报数；</p>
      <p class="indentation-2">b）如果仅有低位发热量或单位热值含碳量无法分机组计量的，可采用相同数值分机组报数；</p>
      <p class="indentation-2">c）如果机组辅助燃料量无法分机组计量的，可按机组发电量比例分配或其他合理方式分机组报数。</p>
      <p>3、对于合并填报的机组，请在新增弹框机组名称中选择合并填报，排放报告中的机组须按照质量控制计划机组信息表单中的机组进行填报，无法再次合并和拆分。</p>
    </write-instruction>
    <!-- ---新增按钮--- -->
    <div class="add-btn" v-if="editOrView == 'edit'">
      <Button type="primary" style="background-color: #009FD9;border-color: #009FD9" @click="handleCreate('add')">新增</Button>
      <Tooltip style="float: right; margin-right:10px" max-width="200" content="同步生产设施后，若机组名称变更，请删除机组重新添加"  placement="bottom">
            <Button type="primary" :loading="btnLoading.handleSync" style="background-color: #009FD9;border-color: #009FD9" @click="handleSync">生产设施同步</Button>
        </Tooltip>
    </div>
    <!-- ---table显示区域--- -->
    <Table border :columns="columns" :data="data" :loading="tableLoading">
      <template slot-scope="{ row }" slot="unitType">
        <span>{{row.unitType}}</span>
        <MonitorAuditPrompt
            v-if="MonitorAuditPromptShow(row.unitName, 'unitType')"
            :concreteData="monitorAuditList"
            :contrastData="{ fieldName: 'unitType',unitName:row.unitName }"
            :type="2"
            :from="'monitor3'"
          />
      </template>
      <template slot-scope="{ row }" slot="fuelType">
        <span>{{row.fuelType}}</span>
        <MonitorAuditPrompt
            v-if="MonitorAuditPromptShow(row.unitName, 'fuelType')"
            :concreteData="monitorAuditList"
            :contrastData="{ fieldName: 'fuelType',unitName:row.unitName }"
            :type="2"
            :from="'monitor3'"
          />
      </template>
      <template slot-scope="{ row }" slot="capacity">
        <span>{{row.capacity}}</span>
        <MonitorAuditPrompt
            v-if="MonitorAuditPromptShow(row.unitName, 'capacity')"
            :concreteData="monitorAuditList"
            :contrastData="{ fieldName: 'capacity',unitName:row.unitName }"
            :type="2"
            :from="'monitor3'"
          />
      </template>
      <template slot-scope="{ row }" slot="action">
        <div class="action-btn clear">
          <a href="javascript:;" @click="handleCreate('edit', row)">编辑</a>
          <a href="javascript:;" @click="handleDel(row)">删除</a>
        </div>
      </template>
    </Table>
    <!-- ---底部按钮组--- -->
    <save-next v-if="editOrView == 'edit'" :btnLoading="btnLoading" @on-save="handleSave" @go-next="goNext" />
    <!-- ---新增或编辑--- -->
    <Modal :title="actionModal.titile" v-model="actionModal.visibility" @on-visible-change="modalChange">
      <Scroll height="500">
        <Form ref="addForm" :model="addForm" :label-width="120" :rules="formRules">
          <FormItem label="行业类别:" style="width: 400px" prop="industry">
            <Select v-model="addForm.industry" :disabled="actionModal.titile == '编辑机组'">
              <Option v-for="(item, index) in industryOptions" :key="index" :value="item">{{ item }}</Option>
            </Select>
          </FormItem>

          <FormItem label="机组名称:" style="width: 400px" prop="unitName">
            <!-- 有排污许可 -->
            <Select v-if="permitCode != ''" v-model="addForm.unitName" :disabled="actionModal.titile == '编辑机组'" @on-change="selectChange">
              <Option v-for="(item, index) in unitOptions" :key="index" :value="item">{{ item }}</Option>
            </Select>
            <!-- 无排污许可 -->
            <Input v-else v-model="addForm.unitName" :disabled="actionModal.titile == '编辑机组'" />
          </FormItem>

          <!-- 合并填报 -->
          <FormItem v-if="addForm.unitName == '合并填报'" label="合并填报的机组范围:" prop="unitScope" style="width: 460px">
            <div class="fuel-name clear">
              <div>
                <Select v-model="addForm.unitScope" multiple @on-change="unitScopeChange">
                  <Option v-for="(item, index) in combinedReportingUnit" :value="item" :key="index">{{ item }}</Option>
                </Select>
              </div>
              <div>
                <Button type="primary" ghost @click="handleAdd">手动新增</Button>
              </div>
            </div>

          </FormItem>
          <!-- 有排污许可---选择其他 -->
          <FormItem v-if="addForm.unitName == '其他'" label="机组名称:" style="width: 400px" prop="otherUnitName">
            <Input v-if="addForm.unitName == '其他'" v-model="addForm.otherUnitName" :disabled="actionModal.titile == '编辑机组'" />
          </FormItem>
          <div v-if="addForm.unitName&&addForm.unitName.indexOf('合并填报')==-1">
            <!-- 机组类型 -->
            <FormItem label="机组类型:" prop="unitType" style="width: 400px">
              <Select v-model="addForm.unitType" @on-change="unitTypeChange">
                <Option v-for="(item,index) in unitTypeOptions" :key="index" :value="item">{{ item }}</Option>
              </Select>
            </FormItem>
            <!-- 机组类型细分 -->
            <FormItem label="机组类型细分:" prop="detailType" style="width: 400px">
              <Select v-model="addForm.detailType" class="self-select">
                <Option v-for="(item,index) in detailTypeOptions" :key="index" :value="item">{{item}}</Option>
              </Select>
            </FormItem>
            <FormItem label="发电燃料类型:" style="width: 400px" prop="fuelType">
              <Select v-model="addForm.fuelType">
                <Option v-for="(item, index) in fuelTypeOptions" :key="index" :value="item">{{ item }}</Option>
              </Select>
            </FormItem>
          </div>
          <!--------------------------------修改处 -->
          <div v-if="addForm.unitName&&addForm.unitName.indexOf('合并填报')!=-1">
            <div v-for="(item,index) in aaaaa" :key="index">

              <FormItem :label="item.unitName+'机组类型'" :prop="'unitType'+index" :rules="{ required: true,message: '机组类型不能为空',trigger: 'change'}" style="width: 400px">
                <Select v-model="item.unitType" @on-change="e=>{combineUnitTypeChange(e,index,'unitType')}">
                  <Option v-for="(item,index) in unitTypeOptions" :key="index" :value="item">{{ item }}</Option>
                </Select>
              </FormItem>

              <FormItem :label="item.unitName+'机组类型细分'" :prop="'detailType'+index" :rules="{required: true,message: '机组类型细分不能为空',trigger: 'change'}" style="width: 400px">
                <Select v-model="item.detailType" class="self-select" @on-change="e=>{rulesChange(e,index,'detailType')}">
                  <Option v-for="(item,index) in item.options" :key="index" :value="item">{{ item }}</Option>
                </Select>
              </FormItem>

              <FormItem :label="item.unitName+'发电燃料类型'" :prop="'fuelType'+index" :rules="{ required: true,message: '发电燃料类型不能为空',trigger: 'change'}" style="width: 400px">
                <Select v-model="item.fuelType" @on-change="e=>{rulesChange(e,index,'fuelType')}">
                  <Option v-for="(item,index) in fuelTypeOptions" :key="index" :value="item">{{ item }}</Option>
                </Select>
              </FormItem>

            </div>
          </div>
          <FormItem label="燃料名称:" style="width: 400px" prop="fuelName">
            <div class="fuel-name clear">
              <div>
                <Input v-model="addForm.fuelName" disabled />
              </div>
              <span style="visibility: hidden">111</span>
              <div>
                <Button type="primary" ghost @click="openTree">选择</Button>
              </div>
            </div>
          </FormItem>

          <div v-if="addForm.unitName&&addForm.unitName.indexOf('合并填报')===-1">
            <FormItem label="装机容量（MW）:" style="width: 400px" prop="capacity">
              <InputNumber style="width:100%" v-model="addForm.capacity" />
            </FormItem>
          </div>
          <!--------------------------------修改处 -->
          <div v-if="addForm.unitName&&addForm.unitName.indexOf('合并填报')!==-1">
            <div v-for="(item,index) in aaaaa" :key="index">
              <FormItem :label="item.unitName+'装机容量（MW）'" :prop="'capacity'+index" :rules="{validator:(rule,value,callback)=>{capacityChange(rule,value,callback,index,'capacity')}, required: true,type:'number',message: '装机容量（MW）不能为空',trigger: 'change'}" style="width: 400px">
                <InputNumber style="width:100%" v-model="item.capacity" @on-change="e=>{rulesChange(e.target.value,index,'capacity')}" />
              </FormItem>
            </div>
          </div>
          <FormItem label="数据来源:" style="width: 400px" prop="dataSource">
            <Select v-model="addForm.dataSource">
              <Option v-for="(item, index) in dataSourceOptions" :key="index" :value="item">{{ item }}</Option>
            </Select>
          </FormItem>
          <FormItem v-if="addForm.dataSource == '其他'" label="数据来源:" style="width: 400px" prop="otherDataSource">
            <Input v-model="addForm.otherDataSource" />
          </FormItem>
        </Form>
      </Scroll>

      <div slot="footer">
        <Button type="text" @click="modalCancel">取消</Button>
        <Button type="primary" style="background-color: #009FD9;border-color: #009FD9" @click="modalConfirm">
          确定
        </Button>
      </div>
    </Modal>
    <!-- 路由离开提示 -->
    <Modal :mask-closable="false" v-model="routerLeave">
      <p slot="header">提示</p>
      <div style="textIndent: 2em">
        <p>
          请确认机组信息是否完整，系统将根据机组信息生成生产设施、主营产品及生产工艺等填报表格。
        </p>
      </div>
      <div slot="footer">
        <Button type="text" @click="nextCancel">取消</Button>
        <Button type="primary" style="background-color: #009FD9;border-color: #009FD9" @click="nextOk">确定</Button>
      </div>
    </Modal>

    <!-- 燃料名称tree -->
    <Modal v-model="fuelNameModal" title="燃料名称">
      <Scroll height="500">
        <Tree @on-toggle-expand="treeExpand" :check-strictly="true" show-checkbox :data="fuelNameData" @on-check-change="checkChange" />
      </Scroll>
      <div slot="footer">
        <Button type="text" class="button-option" @click="closeFuelName">取消</Button>
        <Button type="primary" @click="fuelNameOk">确定</Button>
      </div>
    </Modal>

    <!-- 合并填报手动新增的机组 -->
    <Modal v-model="combinedAddMoadl" title="合并填报机组">
      <div style="textIndent:2em">
        <p>
          若合并填报时，需要选择的机组不属于排污许可证的范围时，可手动输入机组。若合并填报时需要选择的机组属于排污许可证，可在机组列表删除相应的机组后选择。
        </p>
      </div>

      <div v-for="(item,index) in combinedAddOptions" :key="index" style="margin:10px 0 10px 100px">
        <span>合并机组{{index+1}}：</span>
        <span style="display: inline-block;"><Input v-model="combinedAddOptions[index]" /></span>
      </div>

      <Button style="margin-left:178px" type="primary" ghost @click="handleAddunit">增加机组</Button>
      <div slot="footer">
        <Button type="text" @click="combinedClose">取消</Button>
        <Button type="primary" style="background-color: #009FD9;border-color: #009FD9" @click="combinedOk">确定</Button>
      </div>
    </Modal>

  </div>
</template>

<script>
import { mapGetters } from "vuex";

import contentTitle from "@/components/comment/content-title.vue";
import writeInstruction from "@/components/comment/write-instruction.vue";
import saveNext from "@/components/comment/save-next.vue";

import { arrayToHeavy } from "@/lib/util";
import { unitList, unitSave, getMergeUnit, syncBaseInfoDataService, getMonitorAuditInfoService, createMonitorAuditInfoService } from "@/api/monitoring-plan";
import MonitorAuditPrompt from "@/components/monitorAuditPrompt";
export default {
  components: {
    contentTitle,
    writeInstruction,
    saveNext,
    MonitorAuditPrompt
  },
  computed: {
    ...mapGetters(["getUserInfo"]),
    permitCode () {
      return this.getUserInfo.user.permitCode;
    },
    planId () {
      return this.getUserInfo.user.planId;
    },
    companyId () {
      return this.getUserInfo.user.companyId;
    },
    editOrView () {
      return this.getUserInfo.user.editOrView;
    },
  },
  data () {
    return {
      monitorAuditList: {},
      btnLoading: {
        saveUnit: false,
        nextPage: false,
        handleSync: false
      },
      aaaaa: [],
      tableLoading: false,
      fuelNameModal: false,
      combinedAddMoadl: false,
      combinedAddOptions: ['', ''],
      actionModal: {
        visibility: false,
        titile: "",
      },
      addForm: {},
      editData: {},
      formConfig: {
        industry: "", // 行业类别
        unitName: "", // 机组名称
        unitScope: [], // 合并填报的机组名称
        otherUnitName: "", // 其它类别的机组名称
        unitType: "", // 机组类型
        detailType: "", // 详细机组类型
        fuelType: "", // 发电燃料类型
        fuelName: "", // 燃料名称
        capacity: "", // 装机容量（MW）
        dataSource: "", // 数据来源
        otherDataSource: "", // 其他数据来源
      },
      industryOptions: [], // 行业类别
      fuelNameData: [], // 燃料选项
      fuelNameCode: [], // 选中燃料代码
      fuelNameTitle: [], // 选中燃料名称
      fuelTypeOptions: ["燃煤", "燃油", "燃气"], //发电燃料类型
      dataSourceOptions: ["机组运行规程", "铭牌信息", "其他"], // 数据来源
      combinedReportingUnit: [], // 合并填报可选机组
      allOptions: [],
      unitOptions: [], // 机组名称选项
      // 机组类型选项
      unitTypeOptions: [
        "燃煤机组",
        "燃气机组",
        "燃油机组",
        "整体煤气化联合循环发电机组（IGCC）",
        "其他特殊发电机组",
        "燃气蒸汽联合循环发电机组（CCPP）"
      ],
      detailTypeOptions: [],
      //  燃煤机组-->类型细分
      detailTypeOptions1: ["常规燃煤机组", "其他非常规燃煤机组（循环流化床机组、煤矸石机组、水煤浆机组）"],
      // 燃气机组-->类型细分
      detailTypeOptions2: ["B级", "E级", "F级", "H级", "分布式", "内燃机"],
      formRules: {
        industry: [
          {
            required: true,
            message: "行业类别不能为空",
            trigger: "change",
          },
        ],
        unitName: [
          {
            required: true,
            message: "机组名称不能为空",
            trigger: "change",
          },
        ],
        unitType: [
          {
            required: true,
            message: "机组类型不能为空",
            trigger: "change",
          },
        ],
        detailType: [
          {
            required: true,
            message: "详细机组类型不能为空",
            trigger: "blur",
          },
          {
            trigger: "change",
            validator: (rule, value, callback) => {
              if (value === "") {
                callback(new Error("不能为空"));
              } else {
                callback();
              }
            },
          },
        ],
        unitScope: [
          {
            required: true,
            type: "array",
            message: "不能为空",
            trigger: "change",
          },
          {
            trigger: "change",
            validator: (rule, value, callback) => {
              if (value.length < 2) {
                callback(new Error("至少选择两个机组"));
              } else {
                callback();
              }
            },
          },
        ],
        otherUnitName: [
          {
            required: true,
            message: "机组名称不能为空",
            trigger: "change",
          },
        ],
        fuelType: [
          {
            required: true,
            message: "发电燃料类型不能为空",
            trigger: "change",
          },
        ],
        fuelName: [
          {
            required: true,
            message: "燃料名称不能为空",
            trigger: "change",
          },
        ],
        capacity: [
          {
            required: true,
            type: 'number',
            message: "装机容量不能为空",
            trigger: "change",
          },
        ],
        dataSource: [
          {
            required: true,
            message: "数据来源不能为空",
            trigger: "change",
          },
        ],
        otherDataSource: [
          {
            required: true,
            message: "数据来源不能为空",
            trigger: "change",
          },
        ],
      },
      columns: [
        { title: "行业类别", key: "industry", align: "center" },
        { title: "机组名称", key: "unitName", align: "center" },
        {
          title: "机组类型",
          slot: "unitType",
          align: "center",
        },
        {
          title: "机组类型细分",
          key: "detailType",
          align: "center",
        },
        {
          title: "发电燃料类型",
          slot: "fuelType",
          align: "center",
        },
        {
          title: "燃料名称",
          align: "center",
          key: "fuelName",
          render: (h, params) => {
            let arr = [];

            let temData = JSON.parse(JSON.stringify(params.row.fuelName)).split(
              ","
            );
            for (let i = 0; i < temData.length; i++) {
              let tem = h("p", {}, temData[i]);
              arr.push(tem);
            }
            let component=h(MonitorAuditPrompt,{
              props:{
                concreteData:this.monitorAuditList,
                contrastData:{fieldName:'fuelName',unitName:params.row.unitName},
                type:2,
                from:'monitor3'
              }
            })
            arr.push(component)
            return h("div", {}, arr);
          },
        },
        {
          slot: "capacity",
          align: "center",
          renderHeader: (h, parmas) => {
            let arr = [];
            let tempData = ["装机容量", "（MW）"];
            tempData.forEach((item) => {
              let temp = h("p", {}, item);
              arr.push(temp);
            });
            return h("div", {}, arr);
          },
        },
        { title: "数据来源", key: "dataSource", align: "center" },
        {
          title: "操作",
          align: "center",
          width: 160,
          slot: "action",
        },
      ],
      data: [],
      routerLeave: false,
      dataLength: "", // 用于判断机组数据的增减
      // 用于提交时遍历必填项
      leaveConfig: [
        "unitName",
        "industry",
        "unitType",
        "detailType",
        "fuelType",
        "fuelName",
        "capacity",
        "dataSource",
      ],
      // 不可离开路由
      canNotLeaveRoute: [
        "/plan/plan-4",
        "/plan/plan-5",
        "/plan/plan-6",
        "/plan/plan-7",
        "/plan/plan-8",
        "/plan/plan-9",
      ],
    };
  },
  beforeRouteLeave (to, from, next) {
    document
      .querySelector("body")
      .setAttribute("style", "overflow: auto !important;");
    if (this.editOrView == "view") {
      next();
    } else {
      let flag = 0;
      this.data.forEach((item) => {
        this.leaveConfig.forEach((key) => {
          if (item[key] === "") {
            flag++;
            return;
          }
        });
      });
      let newRoutePath = this.canNotLeaveRoute.filter((item) => {
        return item === to.path;
      });
      if (newRoutePath[0] === undefined) {
        next();
      } else {
        if (this.dataLength === this.data.length && flag === 0) {
          next();
        } else if (flag !== 0) {
          this.$Message.warning("请确保列表信息完整!");
        } else {
          this.routerLeave = true;
        }
      }
    }
  },
  async created () {
    this.editOrView == "view" && this.columns.pop();
    await this.getList();
    this.dataLength = this.data.length;
    this.fuelNameData = this.$store.state.fuelNameData.fuelNameData;
  },
  methods: {
    async createMonitorAuditInfoServiceFunc(type){
      await createMonitorAuditInfoService({planId: this.planId, type: 2}).then(res=>{
        if(type !== 'noGet') {
          this.getMonitorAuditRecordInfoService(2);
        }
        this.getMonitorAuditRecordInfoService();
      })
    },
    async getMonitorAuditRecordInfoService(type) {
      let params = {
        planId: this.planId,
        type: type ? type: '', //1-企业基本信息
      };
      await getMonitorAuditInfoService(params).then(async (res) => {
        if (type === 2) {
          this.monitorAuditList = res.body || {};
        } else {
          this.$store.dispatch("monitorAuditRecord/onsiteMapInfo", res.body);
        }
      });
    },
    handleSync(){
      this.btnLoading.handleSync = true
      syncBaseInfoDataService({companyId: this.companyId}).then(res=>{
        this.$Message.success("生产设施同步成功!");
        this.btnLoading.handleSync = false
      }).catch(()=>{
        this.btnLoading.handleSync = false
      })
    },
    combineUnitTypeChange (val, index, key) {
      if (val === "燃煤机组") {
        this.aaaaa[index].options = [...this.detailTypeOptions1];
      } else if (val === "燃气机组") {
        this.aaaaa[index].options = [...this.detailTypeOptions2];
      } else {
        this.aaaaa[index].options = ["/"];
      }
      this.rulesChange(val, index, key)
    },
    capacityChange (rule, value, callback, index, key) {
      let val = this.aaaaa[index][key]
      if (val === "") {
        callback(new Error("不能为空"));
      } else {
        callback();
      }

    },
    rulesChange (val, index, key) {
      this.addForm[key + index] = val
    },
    // 为选择合并填报的机组增加配置项
    unitScopeChange (val) {
      let tempData = []
      let rulesObj = {}
      val.forEach((item, index) => {
        tempData.push({
          unitName: item,
          unitType: "",
          detailType: "",
          fuelType: '',
          capacity: 0,
        })
      })
      tempData.forEach((item, index) => {
        rulesObj['unitType' + index] = ""
        rulesObj['detailType' + index] = ""
        rulesObj['fuelType' + index] = ""
        rulesObj['capacity' + index] = 0
      })
      this.aaaaa = JSON.parse(JSON.stringify(tempData))
      this.addForm = { ...this.addForm, ...rulesObj }
    },
    async getList () {
      this.tableLoading = true;
      let params = {
        planId: this.planId,
        companyId: this.companyId,
      };
      const { body } = await unitList(params);
      this.data = body.unitList;
      this.allOptions = JSON.parse(JSON.stringify(body.unitNameList));
      this.unitOptions = body.unitNameList;
      this.combinedReportingUnit = body.combinedReportingUnit.filter((item) => {
        return item !== "";
      });
      this.industryOptions = body.industryList;
      this.tableLoading = false;
      this.getMonitorAuditRecordInfoService(2);
    },
    handleAdd () {
      this.combinedAddMoadl = true
      this.combinedAddOptions = ["", ""]
    },
    handleAddunit () {
      this.combinedAddOptions.push('')
    },
    combinedOk () {
      this.combinedAddOptions.forEach(item => {
        let option = item.replace(/\s*/g, "")
        if (option !== '') {
          this.combinedReportingUnit.push(item)
          this.addForm.unitScope.push(item)
        }
      })
      this.combinedAddMoadl = false
    },
    // 机组类型与机组参数名称对应
    unitTypeChange (val) {
      if (val === "燃煤机组") {
        this.detailTypeOptions = [...this.detailTypeOptions1];
        this.addForm.detailType = "";
      } else if (val === "燃气机组") {
        this.detailTypeOptions = [...this.detailTypeOptions2];
      } else {
        this.detailTypeOptions = ["/"];
        this.addForm.detailType = "/";
      }
    },
    // 删除
    handleDel (row) {
      // let tempData = JSON.parse(JSON.stringify(this.data))
      let tempData = this.AllMergeUnitChange()
      for (let i = 0; i < tempData.length; i++) {
        if (row.id == tempData[i].id) {
          tempData[i].status = "DEL";
          this.save(tempData).then((res) => {
            if (res === "success") {
              this.$Message.success("删除成功");
            }
          });
        }
      }
    },
    // 机组名称改变触发
    selectChange (value) {
      if (!value == "其他") {
        this.addForm.unitName = value;
        delete this.addForm.otherUnitName;
      } else {
        this.addForm.otherUnitName = "";
      }
      this.addForm.fuelType = "";
      this.addForm.capacity = 0;
    },
    // 移除已存在机组选项名称
    delRepeatUnit (data) {
      let allOptions = JSON.parse(JSON.stringify(data));
      let nowOptions = [];
      this.data.forEach((item) => {
        nowOptions.push(item.unitName);
      });
      // -------------------
      let newArr = arrayToHeavy(allOptions, nowOptions);
      // -------------------
      this.unitOptions = newArr;
    },
    // 新增或编辑赋值
    async handleCreate (type, row) {
      this.actionModal.titile = "新增机组";
      let data = JSON.parse(
        JSON.stringify(this.$store.state.fuelNameData.fuelNameData)
      );
      this.fuelNameData = data;

      this.addForm.unitScope = [];
      this.editData = [];

      if (type == "add") {
        let tempOptions = [];
        this.allOptions.forEach((item) => {
          tempOptions.push(item);
        });
        this.delRepeatUnit(tempOptions);

        this.unitOptions = this.unitOptions.filter((item) => {
          return item.indexOf("合并填报（") == -1;
        });
        this.addForm = JSON.parse(JSON.stringify(this.formConfig));
      } else {
        this.actionModal.titile = "编辑机组";
        this.editData = JSON.parse(JSON.stringify(row));
        // --------数据来源是否在选项中
        let isNameInFuelOptions = false;
        for (let i = 0; i < this.dataSourceOptions.length; i++) {
          if (this.dataSourceOptions[i] == row.dataSource) {
            isNameInFuelOptions = true;
          }
        }
        if (!isNameInFuelOptions && this.editData.dataSource != "") {
          let tempData = this.editData.dataSource;
          this.editData.dataSource = "其他";
          this.editData.otherDataSource = tempData;
        }
        if (row.unitName.indexOf('合并填报') === -1) {
          // 机组类型与机组参数对应
          if (row.unitType === "燃煤机组") {
            this.detailTypeOptions = [...this.detailTypeOptions1];
          } else if (row.unitType === "燃气机组") {
            this.detailTypeOptions = [...this.detailTypeOptions2];
          } else {
            this.detailTypeOptions = ["/"];
          }
          // --------机组名称是否在选项中
          let isNameInOptions = false;
          this.unitOptions = JSON.parse(JSON.stringify(this.allOptions));
          for (let i = 0; i < this.unitOptions.length; i++) {
            if (this.unitOptions[i] == row.unitName) {
              isNameInOptions = true;
            }
          }
          // -------- isNameInOptions==false
          if (!isNameInOptions) {
            if (this.editData.unitName.indexOf("合并填报（") === -1) {
              let tempData = this.editData.unitName;
              this.editData.unitName = "其他";
              this.editData.otherUnitName = tempData;
            }
          }
          this.editData.capacity = Number(this.editData.capacity)
          this.addForm = this.editData;
        } else {
          this.unitOptions.push(row.unitName);
          let params = {
            planId: this.planId,
            unitName: row.unitName
          }
          let tempEditData = []
          const { body } = await getMergeUnit(params)
          tempEditData = this.mergeUnitChange(body.resultList)
          let rulesObj = []
          tempEditData.forEach((item, index) => {
            rulesObj['unitType' + index] = item.unitType
            rulesObj['detailType' + index] = item.detailType
            rulesObj['fuelType' + index] = item.fuelType
            rulesObj['capacity' + index] = Number(item.capacity)
          })

          this.aaaaa = tempEditData
          this.addForm = { ...this.editData, ...rulesObj };
          console.log(this.addForm)
        }
      }
      this.actionModal.visibility = true;
    },
    // 合并填报的机组编辑时获取值
    mergeUnitChange (data) {
      let tempEditData = []
      data.forEach(item => {
        tempEditData.push({
          unitName: item.unitName,
          unitType: item.unitType,
          detailType: item.detailType,
          fuelType: item.fuelType,
          capacity: item.capacity
        })
      })
      tempEditData.forEach(item => {
        if (item.unitType === '燃煤机组') {
          item.options = [...this.detailTypeOptions1];
        } else if (item.unitType === '燃气机组') {
          item.options = [...this.detailTypeOptions2];
        } else {
          item.options = ["/"];
        }
      })
      return tempEditData
    },
    modalCancel () {
      this.actionModal.visibility = false;
    },
    // AllMergeUnitChange
    AllMergeUnitChange () {
      let data = JSON.parse(JSON.stringify(this.data))
      data.forEach(async item => {
        if (item.unitName.indexOf('合并填报') !== -1) {
          let params = {
            planId: this.planId,
            unitName: item.unitName
          }
          let tempEditData = []
          const { body } = await getMergeUnit(params)
          tempEditData = this.mergeUnitChange(body.resultList)
          let tempUnitType = []
          let tempDetailType = []
          let tempFuelType = []
          let tempCapacity = []
          let tempUnitScope = []
          tempEditData.forEach(_item => {
            tempUnitType.push({
              unitName: _item.unitName,
              infoValue: _item.unitType
            })
            tempDetailType.push({
              unitName: _item.unitName,
              infoValue: _item.detailType
            })
            tempFuelType.push({
              unitName: _item.unitName,
              infoValue: _item.fuelType
            })
            tempCapacity.push({
              unitName: _item.unitName,
              infoValue: _item.capacity
            })
            tempUnitScope.push(_item.unitScope)
          })

          item.unitType = tempUnitType
          item.detailType = tempDetailType
          item.fuelType = tempFuelType
          item.capacity = tempCapacity
          item.unitScope = tempUnitScope
        }
      })
      return data
    },
    editMergeUnitChange (data) {
      let tempData = JSON.parse(JSON.stringify(this.aaaaa))
      let tempUnitType = []
      let tempDetailType = []
      let tempFuelType = []
      let tempCapacity = []
      let tempUnitScope = []
      tempData.forEach(item => {
        tempUnitType.push({
          unitName: item.unitName,
          infoValue: item.unitType
        })
        tempDetailType.push({
          unitName: item.unitName,
          infoValue: item.detailType
        })
        tempFuelType.push({
          unitName: item.unitName,
          infoValue: item.fuelType
        })
        tempCapacity.push({
          unitName: item.unitName,
          infoValue: item.capacity
        })
        tempUnitScope.push(item.unitName)
      })
      data.unitType = tempUnitType
      data.detailType = tempDetailType
      data.fuelType = tempFuelType
      data.capacity = tempCapacity
      data.unitScope = tempUnitScope
      return data
    },
    //新增或编辑确认
    modalConfirm () {
      this.$refs.addForm.validate(async (valid) => {
        if (valid) {
          if (this.actionModal.titile == "新增机组") {
            let sendData = await this.AllMergeUnitChange()
            let newData = JSON.parse(JSON.stringify(this.addForm));
            // 机组名称为其它时重新赋值
            if (
              newData.otherUnitName != "" &&
              newData.otherUnitName != undefined
            ) {
              newData.unitName = JSON.parse(
                JSON.stringify(newData.otherUnitName)
              );
              delete newData.otherUnitName;
            }
            // 数据来源名称为其它时重新赋值
            if (
              newData.dataSource == "其他" &&
              newData.otherDataSource != "" &&
              newData.otherDataSource != undefined
            ) {
              newData.dataSource = JSON.parse(
                JSON.stringify(newData.otherDataSource)
              );
              delete newData.otherDataSource;
            }

            // 组合合并填报的机组名称
            let aaa = "";
            if (this.addForm.unitScope.length != 0) {
              aaa = this.addForm.unitScope.join("、");
              newData.unitName = this.addForm.unitName + "(" + aaa + ")";
            }
            newData.planId = this.planId;
            delete newData.id;

            if (newData.unitName.indexOf('合并填报') !== -1) {
              newData = await this.editMergeUnitChange(newData)
            }
            sendData.push(newData)
            this.save(sendData).then((res) => {
              if (res === "success") {
                this.$Message.success("添加成功");
                this.btnLoading.saveUnit = false
              }
            });
          } else {
            // 编辑
            let tempData = await this.AllMergeUnitChange()
            tempData.forEach(async (item, i) => {
              if (item.id == this.addForm.id) {
                let newData = JSON.parse(JSON.stringify(this.addForm));
                // 机组名称为其他时
                if (
                  this.addForm.otherUnitName != "" &&
                  this.addForm.otherUnitName != undefined
                ) {
                  newData.unitName = JSON.parse(
                    JSON.stringify(newData.otherUnitName)
                  );
                  delete newData.otherUnitName;
                }
                // 数据来源为其他时
                if (
                  this.addForm.dataSource == "其他" &&
                  this.addForm.otherDataSource != "" &&
                  this.addForm.otherDataSource != undefined
                ) {
                  newData.dataSource = JSON.parse(
                    JSON.stringify(newData.otherDataSource)
                  );
                  delete newData.otherDataSource;
                }
                if (newData.unitName.indexOf('合并填报') !== -1) {
                  newData = await this.editMergeUnitChange(newData)
                }
                tempData.splice(i, 1, newData);
                this.save(tempData).then((res) => {
                  if (res === "success") {
                    this.$Message.success("编辑成功");
                    this.btnLoading.saveUnit = false
                  }
                });
              }
            });
          }
          this.actionModal.visibility = false;
        }
      });
    },
    // 选中燃料名称tree复选框事件
    checkChange (value) {
      this.fuelNameCode = [];
      this.fuelNameTitle = [];
      value.map((item) => {
        if (item.children.length == 0) {
          this.fuelNameCode.push(item.code);
          this.fuelNameTitle.push(item.title);
        }
      });
    },
    openTree () {
      this.fuelNameModal = true;
      let temp = [];
      if (this.addForm.fuelName !== undefined) {
        temp = JSON.parse(JSON.stringify(this.addForm.fuelName));
      }
      if (temp != "") {
        temp = temp.split(",");
        this.fuelNameData = this.getNode(temp, this.fuelNameData);
      }
    },
    getNode (splitType, data) {
      let cloneBigIndustry = JSON.parse(JSON.stringify(data));
      this.recursive(cloneBigIndustry, splitType);
      return cloneBigIndustry;
    },
    recursive (allArr, arr) {
      for (let i = 0; i < allArr.length; i++) {
        allArr[i].checked = false;
        if (allArr[i].children.length) {
          this.recursive(allArr[i].children, arr);
        } else {
          arr.forEach((item) => {
            if (allArr[i].title == item) {
              allArr[i].checked = true;
            }
          });
        }
      }
    },
    // 确认选择燃料名称
    fuelNameOk () {
      let value = "";
      this.fuelNameTitle.map((item) => {
        value = value + "," + item;
      });
      value = value.substr(1);
      this.addForm.fuelName = value;
      this.fuelNameModal = false;
    },
    closeFuelName () {
      this.fuelNameModal = false;
    },
    modalChange (value) {
      if (value) {
        this.$refs.addForm.resetFields();
      } else {
        this.addForm = JSON.parse(JSON.stringify(this.formConfig));
        this.aaaaa = []
      }
    },
    save (tempData) {
      this.btnLoading.saveUnit = true
      let source = JSON.parse(JSON.stringify(this.data))
      return new Promise((resolve, reject) => {
        const params = {
          listData: tempData === undefined ? source : tempData,
          planId: this.planId,
          companyId: this.companyId,
        };
        unitSave(params).then(async (res) => {
          if (res.status == "200") {
            await this.createMonitorAuditInfoServiceFunc('noGet')
            await this.getList();
            resolve("success");
          } else if (res.status === 600) {
            this.getList();
            this.$Message.error(res.message);
          } else {
            this.$Message.error("操作失败");
          }
        });
      });
    },
    handleSave () {
      this.save().then((res) => {
        if (res === "success") {
          this.$Message.success("保存成功");
          this.btnLoading.saveUnit = false
        }
      });
    },
    goNext () {
      this.$router.push({
        path: "/plan/plan-4",
      });
    },
    nextCancel () {
      this.routerLeave = false;
    },
    nextOk () {
      this.dataLength = this.data.length;
      this.goNext();
    },
    combinedClose () {
      this.combinedAddMoadl = false
    },
    // 解决ie9无法tree子列表无法展开的问题  存在缺陷
    treeExpand () {
      $(".ivu-tree:first").find("ul").attr("style", "");
    },
    MonitorAuditPromptShow(unitName, fieldName) {
      const O_index = this.monitorAuditList.O
        ? this.monitorAuditList.O.findIndex(
            (item) => item.unitName == unitName && item.fieldName == fieldName
          )
        : -1;
      const Y_index = this.monitorAuditList.Y
        ? this.monitorAuditList.Y.findIndex(
            (item) => item.unitName == unitName && item.fieldName == fieldName
          )
        : -1;
      const N_index = this.monitorAuditList.N
        ? this.monitorAuditList.N.findIndex(
            (item) => item.unitName == unitName && item.fieldName == fieldName
          )
        : -1;
      const arr = [O_index, Y_index, N_index];
      let flag = arr.filter((item) => {
        return item !== -1;
      });
      return flag.length !== 0;
    },
  },
};
</script>

<style lang="less" scoped>
.fuel-name {
  & > div:first-of-type {
    width: 70%;
    float: left;
  }

  & > div:last-of-type {
    float: right;
  }
}

.action-btn {
  width: 80%;
  margin: auto;

  & > a:first-of-type {
    float: left;
  }

  & > a:last-of-type {
    float: right;
  }
}

.self-select /deep/ .ivu-select-item {
  white-space: pre-wrap !important;
}
</style>